import TableHead from "@mui/material/TableHead";
import { withStyles } from "@mui/styles";

const StyledTableHead = withStyles((theme) => ({
  root: {
    background: '#ff9300'
  },
}))(TableHead);
export { StyledTableHead };
